const Vue = require('vue')

Vue.component('form-addressing', require('components/geolocation/Addressing.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/addressing.js